module.exports = __webpack_public_path__ + "img/phone-outgoing.38345731.svg";